export default __webpack_public_path__ + "static/media/blob6.b585a921.svg";